import { Stack } from '@common/ui'
import { com } from '@eidu/web'
import { PermissionWithId } from '../input/PermissionsInput'
import PolicyMultiSelect from '../input/PolicyMultiSelect'
import AppliedPoliciesList from '../input/AppliedPoliciesList'
import SelectorEditor from '../input/SelectorEditor'
import { PermissionPolicyDTO } from '../../domain/permission/PermissionPolicyDTO'
import PermissionsMatrix from './PermissionsMatrix'
import EntityType = com.eidu.entity.type.EntityType
import EntitySelector = com.eidu.entity.selector.EntitySelector
import EntityTypeKind = com.eidu.entity.type.EntityTypeKind
import PermissionPolicyId = com.eidu.entity.permission.PermissionPolicyId
import SectionHeader from '../layout/SectionHeader'

type PermissionGrantFormProps = {
  entityTypes: readonly EntityType[]
  userSelector: EntitySelector
  setUserSelector: (selector: EntitySelector) => void
  selectedPermissions: readonly PermissionWithId[]
  setSelectedPermissions: (permissions: readonly PermissionWithId[]) => void
  selectedPolicyIds: ReadonlyArray<PermissionPolicyId>
  setSelectedPolicyIds: (ids: ReadonlyArray<PermissionPolicyId>) => void
  loadedPolicies: ReadonlyArray<PermissionPolicyDTO>
  selectedPolicies: ReadonlyArray<PermissionPolicyDTO>
  hasMorePolicies: boolean
  loadMorePolicies: () => void
  policiesLoading?: boolean
}

const sectionBox = {
  border: '1px solid var(--trellis-color-outline)',
  borderRadius: 'var(--trellis-radius-xs)',
  overflow: 'hidden',
}

const PermissionGrantForm = ({
  entityTypes,
  userSelector,
  setUserSelector,
  selectedPermissions,
  setSelectedPermissions,
  selectedPolicyIds,
  setSelectedPolicyIds,
  loadedPolicies,
  selectedPolicies,
  hasMorePolicies,
  loadMorePolicies,
  policiesLoading,
}: PermissionGrantFormProps) => (
  <Stack gap="md" style={{ width: '100%', overflowX: 'auto' }}>
    <div style={sectionBox}>
      <SectionHeader title="Users" />
      <div style={{ padding: 'var(--trellis-spacing-xs)' }}>
        <SelectorEditor
          selector={userSelector}
          onChange={setUserSelector}
          entityTypes={entityTypes.filter((type) => type.kind.equals(EntityTypeKind.Companion.User))}
          selectorType="target"
        />
      </div>
    </div>
    <div style={sectionBox}>
      <SectionHeader title="Policies" />
      <AppliedPoliciesList
        selectedPolicyIds={selectedPolicyIds}
        selectedPolicies={selectedPolicies}
        loading={policiesLoading}
        onRemove={(id) => setSelectedPolicyIds(selectedPolicyIds.filter((existing) => !existing.equals(id)))}
      />
      <PolicyMultiSelect
        loadedPolicies={loadedPolicies}
        selectedPolicies={selectedPolicies}
        selectedPolicyIds={selectedPolicyIds}
        onChange={setSelectedPolicyIds}
        hasMore={hasMorePolicies}
        loadMore={loadMorePolicies}
        loading={policiesLoading}
      />
    </div>
    <PermissionsMatrix
      entityTypes={entityTypes}
      userSelector={userSelector}
      selectedPermissions={selectedPermissions}
      setSelectedPermissions={setSelectedPermissions}
      selectedPolicies={selectedPolicies}
    />
  </Stack>
)

export default PermissionGrantForm
